import React, { useState } from 'react';
import PushTab from './PushTab';
import TargetCustomer from '../Customer/TargetCustomer/TargetCustomer';

const PushManage = () => {
  const [activeTab, setActiveTab] = useState('push');

  const pushTabs = [
    {
      key: 'push',
      label: '推播平台',
      component: <PushTab />,
    },
    {
      key: 'target-customer',
      label: '目標客群',
      component: <TargetCustomer />,
    },
  ];

  return (
    <div
      style={{
        background: '#f7faf9',
        padding: 24,
        borderRadius: 16,
        marginTop: 24,
      }}>
      {/* 自定義選項卡按鈕 */}
      <div
        style={{
          display: 'flex',
          width: '100%',
          marginBottom: 16,
          borderBottom: '1px solid #f0f0f0',
        }}>
        {pushTabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              flex: 1,
              padding: '12px 16px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              borderBottom:
                activeTab === tab.key
                  ? '2px solid #1890ff'
                  : '2px solid transparent',
              color: activeTab === tab.key ? '#1890ff' : '#666',
              fontWeight: activeTab === tab.key ? 'bold' : 'normal',
              fontSize: '16px',
              textAlign: 'center',
            }}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* 內容區域 */}
      <div>{pushTabs.find((tab) => tab.key === activeTab)?.component}</div>
    </div>
  );
};

export default PushManage;
